import { DEFAULT_PAGE_SIZE } from '@/components';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  useQueryStates,
} from 'nuqs';
import { actionRequiredEnum, workflowStatus } from '../models/search';

export const useWorkflowListSearchQueryStates = () => {
  return useQueryStates({
    page: parseAsInteger.withDefault(1),
    pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
    createdAtFrom: parseAsString,
    createdAtTo: parseAsString,
    tagIds: parseAsArrayOf(parseAsString).withDefault([]),
    keyword: parseAsString,
    actionRequired: parseAsStringEnum(actionRequiredEnum.options).withDefault(
      'all',
    ),
    stageLabelId: parseAsString,
    workflowStatus: parseAsStringEnum(workflowStatus.options).withDefault(
      'all',
    ),
  });
};
